var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFallback = function SvgFallback(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29289 15.2929C3.90237 15.6834 3.90237 16.3166 4.29289 16.7071L15.293 27.7072C15.6835 28.0977 16.3167 28.0977 16.7072 27.7072L27.7073 16.7071C28.0978 16.3166 28.0978 15.6834 27.7073 15.2929L16.7072 4.29277C16.3167 3.90225 15.6835 3.90225 15.293 4.29277L4.29289 15.2929ZM16.0001 25.5859L6.41421 16L16.0001 6.41409L25.586 16L16.0001 25.5859ZM15.2928 9.29274L9.29265 15.2929C8.90212 15.6834 8.90212 16.3166 9.29265 16.7071L15.2928 22.7072C15.6833 23.0978 16.3165 23.0978 16.707 22.7072L22.7071 16.7071C23.0977 16.3166 23.0977 15.6834 22.7071 15.2929L16.707 9.29274C16.3165 8.90221 15.6833 8.90221 15.2928 9.29274ZM15.9999 20.5859L11.414 16L15.9999 11.4141L20.5858 16L15.9999 20.5859Z",
    fill: "#1D386C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFallback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fallback.f63d9037.svg";
export { ForwardRef as ReactComponent };